export default __webpack_public_path__ + "static/media/idea-title-4.192262e2.png";